'use strict';

/**
 *
 * @name: playlistAnalytics
 *
 */

function PlaylistAnalyticsFactory($analytics, $rootScope, $location) {

  'ngInject';

  function love(playlistPage, playlistName) {

    var action;

    if (playlistName) {

      action = playlistPage + ' | ' + playlistName;
    } else {

      action = playlistPage;
    }

    var properties = {
      eventAction: action,
      eventPoints: 0,
      attributes: {
        label: $location.path()
      }
    };

    return $analytics.eventTrack('Love', properties);
  }

  function rate(playlistPage, playlistName) {

    var action;

    if (playlistName) {

      action = playlistPage + ' | ' + playlistName;
    } else {

      action = playlistPage;
    }

    var properties = {
      eventAction: action,
      eventPoints: 0,
      attributes: {
        label: $location.path()
      }
    };

    return $analytics.eventTrack('Rating', properties);
  }

  function playlistLP(playlist) {

    var properties = {
      eventAction: 'Playlist | ' + playlist.translations[$rootScope.lang].title + ' | ' + playlist.translations[$rootScope.lang].title,
      eventPoints: 0,
      attributes: {
        label: $location.path()
      }
    };

    return $analytics.eventTrack('Video Access Methods', properties);
  }

  function socialShare(network, playlist) {

    var properties = {
      eventAction: 'share | ' + network,
      eventPoints: 0,
      attributes: {
        label: playlist.translations[$rootScope.lang].title
      }
    };

    return $analytics.eventTrack('Playlist Interactions', properties);
  }

  return {
    love: love,
    playlistLP: playlistLP,
    rate: rate,
    socialShare: socialShare,
  };
}

export default PlaylistAnalyticsFactory;



// WEBPACK FOOTER //
// ./app/pages/playlist/playlist-analytics.factory.js